/* global $:false */
(function() {
  'use strict';

  angular
    .module('admin.campaigns.promo', [
      'admin.campaigns.promo.edit',
      'admin.campaigns.promo.service',
      'admin.campaigns.promo.codes'
    ])
    .controller('PromoCtrl', PromoCtrl);

  /** @ngInject */
  function PromoCtrl($scope, $state, $timeout, $stateParams, CampaignsService, PromoService, UploadService) {
    var vm = this;
    vm.parentId = parseInt($stateParams.parentId);
    vm.pathImg = '';
    vm.load = false;
    vm.items = [];
    vm.pathImg = '';
    vm.load = false;
    vm.model = {};
    vm.totalUsers = 0;
    vm.usersPerPage = 25;
    vm.oldPage = 0;
    vm.currentPage = 25;
    vm.first = true;
    vm.totalItems = 0;
    vm.pagination = {
      current: 1
    };

    vm.sortTypePromo = 'id-desc';
    vm.sortReversePromo = true;

    load(1);

    var oldSortTypePromo;
    function load(pageNumber){
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }
      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      }
      else {
        vm.first = false;
      }

      oldSortTypePromo = angular.copy(vm.sortTypePromo);
      PromoService.list(vm.parentId, vm.oldPage, 25, vm.sortTypePromo).then(function(result){
        CampaignsService.get(vm.parentId).then(function(resultCam){
          var items = result.results;
          if (vm.totalItems === 0) {
            vm.totalItems = result.ct;
          }
          for (var i = 0; i < items.length; i++) {
            items[i].load = false;
            if (items[i]['ts-x'] !== undefined) {
              items[i]['ts-x'] = new Date(parseInt(items[i]['ts-x'].toString().substring(0, items[i]['ts-x'].toString().length - 3)));
            }

            items[i].pc = resultCam.results;
          }

          vm.sortTypePromo = oldSortTypePromo;
          vm.items = items;
        });
      });
    }

    vm.pageChanged = function(newPage) {
      vm.sortTypePromo = oldSortTypePromo;
      load(newPage);
    };

    vm.back = function(){
      $state.go('admin.promo_campaigns');
    };

    vm.add = function(){
      $state.go('admin.promo_campaigns.promo.edit', {id: 0});
    };

    vm.edit = function(item){
      $state.go('admin.promo_campaigns.promo.edit', {id: item.id});
    };

    vm.delete = function(item){
      swal({
        title: "Are you sure?",
        text: "",
        type: "warning",
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: "slide-from-top"
      }, function(isConfirm){
        if (isConfirm){
          PromoService.remove(item.id).then(function(){
            if (vm.items.length === 1 || vm.items.length === 25) {
              $state.reload();
            } else {
              vm.sortTypePromo = oldSortTypePromo;
              load(vm.pagination.current);
            }
          }, function() {
            $timeout(function(){
              swal('You cannot delete a promo with promo codes active', '', 'error');
            }, 500);
          });
        } else {
          return;
        }
      });
    };

    vm.sortPromo = function(type){
      vm.sortReversePromo = !vm.sortReversePromo;
      if (vm.sortReversePromo) {
        vm.sortTypePromo = type + '-asc';
      } else {
        vm.sortTypePromo = type + '-desc';
      }
      load(vm.pagination.current);
    };

    vm.up = function(item){
      item.load = true;
      UploadService.savePromo('promos', item.upload, item.id).then(function(){
        item.load = false;
        swal('Upload complete', '', 'success');
      }, function(){
        $timeout(function(){
          swal('That code is already associated with this promo', '', 'error');
        }, 250);
      });
    };
  }

})();
